/**
 * @desc 获取角色登录首页
 */
const URL = "/rantion-ucenter";
import http, { updateResponse } from "@/http";
export function request(roleId: string | number, options?: any) {
  return updateResponse(
    http(URL + `/sysRoleData/getRoleHomePage/${roleId}`, {
      method: "GET",

      ...options,
    }),
  );
}
